(()=>{
  const CONFIG_SELECTOR='[data-eg-sale-integrity-config]';
  const GRID_SELECTOR='#ProductGridContainer #product-grid';
  const PRODUCT_META='[data-eg-native-badge-meta]';
  const HANDLE_META='[data-eg-card-v3-meta]';
  const productCache=new Map();
  let activeGrid=null;
  let observer=null;
  let scheduled=false;

  const getConfig=()=>{
    const node=document.querySelector(CONFIG_SELECTOR);
    if(!node)return null;
    try{return JSON.parse(node.textContent||'{}');}catch(_){return null;}
  };

  const numeric=(value)=>{
    const n=Number(value);
    return Number.isFinite(n)?n:0;
  };

  const setChecked=(item,valid)=>{
    item.dataset.egSaleChecked='true';
    item.dataset.egSaleValid=valid?'true':'false';
    item.hidden=!valid;
    if(valid)item.classList.add('scroll-trigger--cancel');
  };

  const immediateSale=(item)=>{
    const meta=item.querySelector(PRODUCT_META);
    if(!meta)return false;
    const price=numeric(meta.dataset.egPrice);
    const compare=numeric(meta.dataset.egCompareAt);
    const available=meta.dataset.egAvailable!=='false';
    return available&&compare>price&&price>0;
  };

  const getHandle=(item)=>item.querySelector(HANDLE_META)?.dataset.egProductHandle||'';

  const verifyByProductJson=(handle)=>{
    if(!handle)return Promise.resolve(false);
    if(productCache.has(handle))return productCache.get(handle);
    const root=window.Shopify?.routes?.root||'/';
    const url=`${root}products/${encodeURIComponent(handle)}.js`;
    const request=fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then((response)=>{
        if(!response.ok)throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((product)=>Array.isArray(product?.variants)&&product.variants.some((variant)=>{
        const price=numeric(variant.price);
        const compare=numeric(variant.compare_at_price);
        return variant.available!==false&&price>0&&compare>price;
      }))
      .catch(()=>false);
    productCache.set(handle,request);
    return request;
  };

  const verifyItem=async(item)=>{
    if(item.dataset.egSaleChecked==='true')return item.dataset.egSaleValid==='true';
    let valid=immediateSale(item);
    if(!valid)valid=await verifyByProductJson(getHandle(item));
    setChecked(item,valid);
    return valid;
  };

  const nextPageUrl=(scope)=>scope.querySelector('.pagination-wrapper a.pagination__item--prev')?.href||'';

  const fetchCandidatePage=async(url)=>{
    const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
    if(!response.ok)throw new Error(`HTTP ${response.status}`);
    const html=await response.text();
    const doc=new DOMParser().parseFromString(html,'text/html');
    const container=doc.querySelector('#ProductGridContainer');
    const items=container?Array.from(container.querySelectorAll('#product-grid > .grid__item')):[];
    await Promise.all(items.map(verifyItem));
    return {
      items:items.filter((item)=>item.dataset.egSaleValid==='true'),
      nextUrl:container?nextPageUrl(container):''
    };
  };

  const setResultLabels=(config)=>{
    ['ProductCount','ProductCountDesktop'].forEach((id)=>{
      const el=document.getElementById(id);
      if(el)el.textContent=config.verifiedLabel||'Ofertas con descuento real';
    });
    document.querySelectorAll('.mobile-facets__count').forEach((el)=>{
      el.textContent=config.verifiedLabel||'Ofertas con descuento real';
    });
  };

  const announce=(message)=>{
    const status=document.querySelector('[data-eg-sale-integrity-status]');
    if(status)status.textContent=message||'';
  };

  const removeNativePagination=(container)=>{
    const pagination=container.querySelector('.pagination-wrapper');
    if(pagination)pagination.remove();
  };

  const addLoadMore=(collectionNode,state,config,target)=>{
    collectionNode.querySelector('.eg-sale-integrity__load-more-wrap')?.remove();
    if(!state.buffer.length&&!state.nextUrl)return;
    const wrap=document.createElement('div');
    wrap.className='eg-sale-integrity__load-more-wrap';
    const button=document.createElement('button');
    button.type='button';
    button.className='eg-sale-integrity__load-more';
    button.textContent=config.loadMoreLabel||'Cargar más ofertas';
    wrap.appendChild(button);
    const trust=collectionNode.querySelector('.egt-collection-trust');
    if(trust)collectionNode.insertBefore(wrap,trust);else collectionNode.appendChild(wrap);

    button.addEventListener('click',async()=>{
      button.disabled=true;
      button.textContent=config.loadingLabel||'Buscando más ofertas…';
      let added=0;
      try{
        while(added<target&&(state.buffer.length||state.nextUrl)){
          while(state.buffer.length&&added<target){
            const item=state.buffer.shift();
            state.grid.appendChild(item);
            added+=1;
          }
          if(added>=target||!state.nextUrl)break;
          const page=await fetchCandidatePage(state.nextUrl);
          state.nextUrl=page.nextUrl;
          state.buffer.push(...page.items);
        }
        announce(added?`${added} ofertas adicionales cargadas.`:'No hay más ofertas con descuento real.');
      }catch(error){
        console.error('[EASY GAMES] No se pudieron cargar más ofertas.',error);
        announce('No se pudieron cargar más ofertas en este momento.');
      }finally{
        button.disabled=false;
        button.textContent=config.loadMoreLabel||'Cargar más ofertas';
        addLoadMore(collectionNode,state,config,target);
      }
    });
  };

  const processGrid=async(config)=>{
    const grid=document.querySelector(GRID_SELECTOR);
    if(!grid||grid===activeGrid)return;
    activeGrid=grid;
    const container=document.getElementById('ProductGridContainer');
    const collectionNode=grid.closest('.collection');
    if(!container||!collectionNode)return;

    const rawItems=Array.from(grid.querySelectorAll(':scope > .grid__item'));
    const target=Math.max(rawItems.length,1);
    const state={grid,buffer:[],nextUrl:nextPageUrl(container)};
    const nativePagination=container.querySelector('.pagination-wrapper');
    if(nativePagination)nativePagination.style.visibility='hidden';

    try{
      await Promise.all(rawItems.map(verifyItem));
      let validCount=rawItems.filter((item)=>item.dataset.egSaleValid==='true').length;
      let scanned=0;
      if(config.autoFill!==false){
        const maxPages=Math.max(1,numeric(config.maxAutoPages)||5);
        while(validCount<target&&state.nextUrl&&scanned<maxPages){
          const page=await fetchCandidatePage(state.nextUrl);
          scanned+=1;
          state.nextUrl=page.nextUrl;
          for(const item of page.items){
            if(validCount<target){
              grid.appendChild(item);
              validCount+=1;
            }else{
              state.buffer.push(item);
            }
          }
        }
      }
      removeNativePagination(container);
      setResultLabels(config);
      addLoadMore(collectionNode,state,config,target);
      announce(`${validCount} ofertas con descuento real visibles.`);
    }catch(error){
      console.error('[EASY GAMES] Error al validar la colección de ofertas.',error);
      rawItems.forEach((item)=>{if(item.dataset.egSaleChecked!=='true')setChecked(item,true);});
      if(nativePagination)nativePagination.style.visibility='';
      announce('La validación de ofertas no pudo completarse.');
    }
  };

  const schedule=(config)=>{
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(()=>{
      scheduled=false;
      const grid=document.querySelector(GRID_SELECTOR);
      if(grid!==activeGrid)processGrid(config);
      else setResultLabels(config);
    });
  };

  const init=()=>{
    const config=getConfig();
    if(!config?.enabled)return;
    processGrid(config);
    const container=document.getElementById('ProductGridContainer');
    if(container){
      observer?.disconnect();
      observer=new MutationObserver(()=>schedule(config));
      observer.observe(container,{childList:true,subtree:true});
    }
    document.addEventListener('shopify:section:load',()=>{
      activeGrid=null;
      schedule(config);
    });
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
